<div class="container h-100">
  <div class="row d-flex h-100 align-items-center">
    <div class="col-12 col-sm order-2 order-sm-1 text-center text-sm-left" @enter>
      <h1 class="mb-3">
        <span class="d-none d-sm-inline">
          Hi <span *ngIf="(userService.user$ | async) as user">{{ user.preferredName }}</span
          >, <br />
          we're here to help.
        </span>
        <span class="d-inline d-sm-none"> We're here to help. </span>
      </h1>
      <a routerLink="/appointments/new" class="btn btn-primary mb-3 call-to-action"> Book Visit </a>
      <p>
        <span class="d-none d-sm-inline">Got questions?</span>
        <a routerLink="/messages" class="text-nowrap font-weight-normal message-us">
          Message us <i class="fa fa-chevron-right"></i
        ></a>
      </p>
    </div>
    <div class="col-12 col-sm order-1 order-sm-2 px-3">
      <om-svg-physicians class="d-block img-fluid mx-auto"></om-svg-physicians>
    </div>
  </div>
</div>
